<template>
  <div class="custom-margin-full-page">
    <img width="80" class="custom-shape-red-course" src="@/assets/red-dots.png" alt="red-dots">
    <v-card elevation="0" class="lessons-container">
      <v-card-title>درس های من</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
             {{courseName}}
          </v-col>
          <v-col cols="12" class="text-left">
            <v-icon class="back-link-icon" large
                    @click="$router.push('/dashboard/my-courses')">mdi-arrow-left
            </v-icon>
          </v-col>
          <v-col cols="12" class="index-lessons-container">
            <v-row>
              <v-col cols="12" class="white--text">
                تعداد درس های باز: &nbsp;
                {{ details.filter(lesson => lesson.status === 'open').length }}
              </v-col>
              <v-col cols="12" class="white--text">
                تعداد درس های بسته : &nbsp;
                {{ details.filter(lesson => lesson.status === 'close').length }}
              </v-col>
            </v-row>
          </v-col>
          <v-divider></v-divider>
          <v-col cols="12" class="index-lessons-container">
            <v-row>
              <v-col cols="2" class="mx-0 px-1" v-for="(lesson,index) in details" :key="lesson.id">
                <v-btn v-if="lesson.status === 'open'" color="white" class="normal-button" block elevation="0"
                       @click="$router.push('/dashboard/my-courses/item/'+lesson.id+'/'+classId+'/'+courseId)">
                  {{ index + 1 }}
                </v-btn>
                <v-btn v-else disabled color="black" class="normal-button" block elevation="0">
                  {{ index + 1 }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "MyLessonsMobile",
  props: ['details','classId','courseId','courseName'],
  data() {
    return {}
  },
  methods: {},
  mounted() {
  }
}
</script>

<style scoped>
.custom-margin-full-page {
  margin: 5vh 5vw 0 5vw;
}

.normal-button {
  letter-spacing: normal;
  color: black;
}

.custom-shape-red-course {
  position: absolute;
  margin-right: -6vw;
  margin-top: -3vh;
  z-index: 1 !important;
}

.lessons-container {
  z-index: 2 !important;
}

.custom-shape-circle-red-course {
  transform: rotate(15deg);
  position: absolute;
  top: 6vh;
  right: 5vw;
}
.back-link-icon {
  color: #413e3e !important;
}

.back-link-icon:hover {
  color: orangered !important;
}
.index-lessons-container{
  background-color: #1ab69d;
  border-radius: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>